import { NameValuePair } from "../../schema/types/base";
import { v4 as uuidv4 } from "uuid";

export function inputToTags(input: NameValuePair[]): Record<string, any> {
  const res: Record<string, any> = {};
  if (!input) {
    return res;
  }
  for (const inputElement of input) {
    res[inputElement.name] = inputElement.value;
  }
  return res;
}

export function tagsToInput(tags?: Record<string, any>): NameValuePair[] {
  const res: NameValuePair[] = [];
  for (const key of Object.keys(tags || {})) {
    res.push({
      id: uuidv4(),
      name: key,
      value: (tags || {})[key] || "",
    });
  }
  return res;
}
